import { RowData } from '../components/DiagnosticsReport/SkillPerformanceByClassTable';
import { createAndExportCSV } from './createAndExportGenericCSV';

export const DIAGNOSTIC_SKILLS_HEADERS = ['Skill Name', 'Type', 'Unit', 'Not Placed Out', 'Placed Out'];

export const DIAGNOSTIC_SKILLS_HEADERS_WITH_ID = [
  'Skill ID',
  'Skill Name',
  'Type',
  'Unit',
  'Not Placed Out',
  'Placed Out',
];

export function formatDiagnosticSkillsRowsForCsv(rows: RowData[], opts?: { includeId?: boolean }): string[][] {
  const includeId = !!opts?.includeId;

  return rows.map(r => {
    const base = [
      r.skillName ?? '',
      r.type ?? '',
      r.unit ?? '',
      String(r.NOT_PLACED_OUT ?? 0),
      String(r.PLACED_OUT ?? 0),
    ];

    return includeId ? [String(r.skillId ?? ''), ...base] : base;
  });
}

export function exportDiagnosticSkillsCsv(rows: RowData[], opts?: { includeId?: boolean }) {
  const includeId = !!opts?.includeId;
  const headers = includeId ? DIAGNOSTIC_SKILLS_HEADERS_WITH_ID : DIAGNOSTIC_SKILLS_HEADERS;
  const csvRows = formatDiagnosticSkillsRowsForCsv(rows, { includeId });
  createAndExportCSV(headers, csvRows);
}
